export enum PositionIcon {
	Sales = "Sales",
	Accountant = "Accountant",
	Technician = "Technician",
	Developer = "Developer",
	SocialMediaSpecialist = "SocialMediaSpecialist",
}
